<template>
  <div>
    <div class="bg">
      <v-container>
        <v-row class="text-center" justify="center" align="center">
          <v-col cols="2" sm="2" md="1" lg="1">
            <v-tooltip v-if="isLoggedInUser" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="backToSubscription()"
                  v-bind="attrs"
                  v-on="on"
                  color="white"
                  dense
                  icon
                >
                  <v-icon>mdi-arrow-left-bold-circle</v-icon>
                </v-btn>
              </template>
              <span>Back To Subscription</span>
            </v-tooltip>
          </v-col>
          <v-col cols="8" sm="8" md="10" lg="10">
            <h2 class="white--text hidden-sm-and-down">
              Facebook Insights Report
            </h2>
            <h3 class="white--text hidden-md-and-up">
              Facebook Insights Report
            </h3>
          </v-col>
          <v-col cols="2" sm="2" md="1" lg="1">
            <v-menu v-model="menuOpen" offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="white"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  rounded
                  fab
                  small
                >
                  <v-icon dense color="primary">mdi-filter-variant</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="section in selectSections"
                  :key="section.value"
                >
                  <v-list-item-title>{{ section.name }}</v-list-item-title>
                  <v-list-item-action>
                    <v-checkbox
                      v-model="selectedSections"
                      :value="section.value"
                      @click.stop
                    ></v-checkbox>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div class="lightgrey" v-if="selectedSections.includes('campaignsSection')">
      <v-container>
        <v-row>
          <v-col cols="12" class="my-6 text-center">
            <h1>Campaigns Overview</h1>
            <p>Quick glance at the Campaigns totals from the last 30 Days</p>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div v-if="selectedSections.includes('campaignsSection')">
      <v-container v-if="this.campaigns != null">
        <v-row justify="center" align="center" class="text-center my-3">
          <v-col cols="12">
            <h2>Overall Totals</h2>
          </v-col>
          <v-col cols="6" sm="6" md="2" lg="2">
            <v-card>
              <v-card-text>
                <h4>Total Campaigns</h4>
                {{ this.campaignsTotals.totalCampaigns }}
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6" sm="6" md="2" lg="2">
            <v-card>
              <v-card-text>
                <h4>Total Impressions</h4>
                {{ this.campaignsFacebookTotals.facebookTotalImpressions }}
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6" sm="6" md="2" lg="2">
            <v-card>
              <v-card-text>
                <h4>Total Reach</h4>
                {{ this.campaignsFacebookTotals.facebookTotalReach }}
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6" sm="6" md="2" lg="2">
            <v-card>
              <v-card-text>
                <h4>Total Clicks</h4>
                {{ this.campaignsFacebookTotals.facebookTotalClicks }}
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6" sm="6" md="2" lg="2">
            <v-card>
              <v-card-text>
                <h4>Total Facebook Spend</h4>
                ZAR{{
                  this.campaignsFacebookTotals.facebookTotalSpend
                    | formatTotalAmount
                }}
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6" sm="6" md="2" lg="2">
            <v-card>
              <v-card-text>
                <h4>Total Instagram Spend</h4>
                ZAR{{
                  this.campaignsInstagramTotals.instagramTotalSpend
                    | formatTotalAmount
                }}
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6" sm="6" md="2" lg="2">
            <v-card>
              <v-card-text>
                <h4>Total Spend</h4>
                ZAR{{
                  this.campaignsTotals.campaignsTotalSpend | formatTotalAmount
                }}
              </v-card-text>
            </v-card>
          </v-col>
          <v-col v-if="noGenderData == false" cols="12">
            <v-divider class="mb-3"></v-divider>
            <h2>Averages & Insights</h2>
          </v-col>
          <v-col v-if="noGenderData == false" cols="12" sm="12" md="6" lg="6">
            <v-card flat class="py-3 px-3">
              <h2>Metrics By Gender</h2>
              <apexchart
                type="bar"
                height="450"
                :options="chartOptionsTotalsByGender"
                :series="totalsByGenderSeries"
              ></apexchart>
            </v-card>
          </v-col>
          <v-col v-if="noGenderData == false" cols="12" sm="12" md="6" lg="6">
            <v-card flat class="py-3 px-3">
              <h2>Spend By Gender</h2>
              <apexchart
                type="donut"
                height="400"
                :options="chartOptionsSpendByGender"
                :series="totalGenderSpendSeries"
              >
              </apexchart>
            </v-card>
          </v-col>
          <v-col v-if="noGenderData == false" cols="12" sm="12" md="6" lg="6">
            <v-card flat class="py-3 px-3">
              <h2>Metrics By Age</h2>
              <apexchart
                type="bar"
                height="450"
                :options="chartOptionsTotalsByAge"
                :series="totalsByAgeSeries"
              ></apexchart>
            </v-card>
          </v-col>
          <v-col v-if="noGenderData == false" cols="12" sm="12" md="6" lg="6">
            <v-card flat class="py-3 px-3">
              <h2>Spend By Age</h2>
              <apexchart
                type="donut"
                height="400"
                :options="chartOptionsSpendByAge"
                :series="totalAgeSpendSeries"
              >
              </apexchart>
            </v-card>
          </v-col>
          <v-col
            v-if="this.performanceByPlacement.length != 0"
            cols="12"
            class="my=3"
          >
            <h2>Preformance By Social Placement</h2>
            <v-data-table
              :headers="headers"
              :items="performanceByPlacement"
              :items-per-page="12"
              hide-default-footer
              class="elevation-1"
            >
              <template v-slot:[`item.spend`]="{ item }">
                ZAR {{ item.spend | toFixed2 }}
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-container>
      <v-container v-else>
        <v-row>
          <v-col cols="12" class="text-center">
            <p class="mb-0">No Data</p>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div class="lightgrey" v-if="selectedSections.includes('postsSection')">
      <v-container>
        <v-row>
          <v-col cols="12" class="my-6 text-center">
            <h1>Posts Overview</h1>
            <p>Quick glance at the Posts totals from the last 30 Days</p>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div v-if="selectedSections.includes('postsSection')">
      <v-container>
        <v-row justify="center" align="center" class="text-center mt-2">
          <v-col cols="12">
            <h2>Overview On All Posts</h2>
          </v-col>
          <v-col cols="6" sm="6" md="2" lg="2">
            <v-card>
              <v-card-text class="px-3">
                <h5>Total Posts</h5>
                {{ this.postsTotals.posts }}
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6" sm="6" md="2" lg="2">
            <v-card>
              <v-card-text class="px-3">
                <h5>Total Clicks</h5>
                {{ this.postsTotals.clicks }}
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6" sm="6" md="2" lg="2">
            <v-card>
              <v-card-text class="px-3">
                <h5>Total Impressions</h5>
                {{ this.postsTotals.impressions }}
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6" sm="6" md="2" lg="2">
            <v-card>
              <v-card-text class="px-3">
                <h5>Total Reach</h5>
                {{ this.postsTotals.reach }}
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6" sm="6" md="2" lg="2">
            <v-card>
              <v-card-text class="px-3">
                <h5>Total Engagement</h5>
                {{ this.postsTotals.engagement }}
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6" sm="6" md="2" lg="2">
            <v-card>
              <v-card-text class="px-3">
                <h5>Total Viral</h5>
                {{ this.postsTotals.viral }}
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6" sm="6" md="2" lg="2">
            <v-card>
              <v-card-text class="px-3">
                <h5>Total Non-Viral</h5>
                {{ this.postsTotals.non_viral }}
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6" sm="6" md="2" lg="2">
            <v-card>
              <v-card-text class="px-3">
                <h5>Total Negative Feedback</h5>
                {{ this.postsTotals.negative_feedback }}
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6" sm="6" md="2" lg="2">
            <v-card>
              <v-card-text class="px-3">
                <h5>Total Shares</h5>
                {{ this.postsTotals.shares }}
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6" sm="6" md="2" lg="2">
            <v-card>
              <v-card-text class="px-3">
                <h5>Total Comments</h5>
                {{ this.postsTotals.comments }}
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12">
            <v-divider class="mb-3"></v-divider>
            <h2>Overview On Top Ten Posts</h2>
          </v-col>
          <v-col class="postsbox mb-3" cols="12">
            <v-card
              min-width="300"
              max-width="300"
              class="py-4 px-4 mx-2 cardsradius"
              v-for="item in this.posts.topTenPosts"
              :key="item.id"
            >
              <v-img
                :src="item.image_url"
                :lazy-src="item.image_url"
                width="100%"
                max-height="200px"
                min-height="200px"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="grey lighten-5"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
              <h5 class="my-1 mx-1">{{ item.date_created }}</h5>
              <v-row>
                <v-col cols="12 pb-0 mt-2 postcontent">
                  {{ item.message }}
                  <v-divider class="mt-2"></v-divider>
                </v-col>
                <v-col cols="4" class="text-center px-1">
                  <p v-if="item.reactions.like" class="mb-0 reactiontext">
                    {{ item.reactions.like }}
                  </p>
                  <p v-else class="mb-0 reactiontext">0</p>
                  <v-img
                    src="../assets/like.png"
                    width="25px"
                    class="mx-auto"
                  />
                </v-col>
                <v-col cols="4" class="text-center px-1">
                  <p v-if="item.reactions.love" class="mb-0 reactiontext">
                    {{ item.reactions.love }}
                  </p>
                  <p v-else class="mb-0 reactiontext">0</p>
                  <v-img
                    src="../assets/love.png"
                    width="25px"
                    class="mx-auto"
                  />
                </v-col>
                <v-col cols="4" class="text-center px-1">
                  <p v-if="item.reactions.anger" class="mb-0 reactiontext">
                    {{ item.reactions.anger }}
                  </p>
                  <p v-else class="mb-0 reactiontext">0</p>
                  <v-img
                    src="../assets/angry.png"
                    width="25px"
                    class="mx-auto"
                  />
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-divider></v-divider>
                </v-col>
                <v-col cols="12" class="text-center my-2">
                  <v-icon color="primary">mdi-share-variant</v-icon> Shares
                  {{ item.shares }}
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-divider></v-divider>
                </v-col>
                <v-col cols="12" class="text-center my-2">
                  <v-icon color="primary">mdi-sticker-emoji</v-icon> Total
                  Reactions
                  {{
                    (item.reactions.like ?? 0) +
                    (item.reactions.love ?? 0) +
                    (item.reactions.anger ?? 0)
                  }}
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-divider></v-divider>
                </v-col>
                <v-col cols="12" class="text-center">
                  <v-dialog
                    transition="dialog-bottom-transition"
                    max-width="600"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="primary"
                        v-bind="attrs"
                        v-on="on"
                        small
                        rounded
                        >Insights</v-btn
                      >
                    </template>
                    <template v-slot:default="dialog">
                      <v-card>
                        <v-toolbar color="primary" dark
                          >Post Insights</v-toolbar
                        >
                        <v-card-text>
                          <v-row class="my-2">
                            <v-col
                              cols="6"
                              sm="6"
                              md="4"
                              lg="4"
                              class="text-center mx-auto"
                            >
                              <v-card>
                                <v-card-text class="py-2">
                                  <h4>Clicks</h4>
                                  {{ item.clicks }}
                                </v-card-text>
                              </v-card>
                            </v-col>
                            <v-col
                              cols="6"
                              sm="6"
                              md="4"
                              lg="4"
                              class="text-center mx-auto"
                            >
                              <v-card>
                                <v-card-text class="py-2">
                                  <h4>Impressions</h4>
                                  {{ item.impressions }}
                                </v-card-text>
                              </v-card>
                            </v-col>
                            <v-col
                              cols="6"
                              sm="6"
                              md="4"
                              lg="4"
                              class="text-center mx-auto"
                            >
                              <v-card>
                                <v-card-text class="py-2">
                                  <h4>Reach</h4>
                                  {{ item.reach }}
                                </v-card-text>
                              </v-card>
                            </v-col>
                            <v-col
                              cols="6"
                              sm="6"
                              md="4"
                              lg="4"
                              class="text-center mx-auto"
                            >
                              <v-card>
                                <v-card-text class="py-2">
                                  <h4>Engagement</h4>
                                  {{ item.engagement }}
                                </v-card-text>
                              </v-card>
                            </v-col>
                            <v-col
                              cols="6"
                              sm="6"
                              md="4"
                              lg="4"
                              class="text-center mx-auto"
                            >
                              <v-card>
                                <v-card-text class="py-2">
                                  <h4>Viral</h4>
                                  {{ item.viral }}
                                </v-card-text>
                              </v-card>
                            </v-col>
                          </v-row>
                        </v-card-text>
                        <v-card-actions class="justify-end">
                          <v-btn text @click="dialog.value = false"
                            >Close</v-btn
                          >
                        </v-card-actions>
                      </v-card>
                    </template>
                  </v-dialog>
                  <v-btn
                    class="ml-2"
                    small
                    rounded
                    color="primary"
                    :href="item.permalink_url"
                    target="_blank"
                  >
                    View Post
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div class="lightgrey" v-if="selectedSections.includes('adsSection')">
      <v-container>
        <v-row>
          <v-col cols="12" class="my-6 text-center">
            <h1>Ads Overview</h1>
            <p>Quick glance at the Ads totals from the last 30 Days</p>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div v-if="selectedSections.includes('adsSection')">
      <v-container v-if="this.ads != null">
        <v-row justify="center" align="center" class="text-center mt-2">
          <v-col cols="12">
            <h2>Overall Totals</h2>
          </v-col>
          <v-col cols="6" sm="6" md="2" lg="2">
            <v-card>
              <v-card-text>
                <h5>Total Ads</h5>
                {{ this.adsFacebookTotals.total_ads }}
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6" sm="6" md="2" lg="2">
            <v-card>
              <v-card-text>
                <h5>Total Clicks</h5>
                {{ this.facebookTotalsOnly.facebookClicks }}
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6" sm="6" md="2" lg="2">
            <v-card>
              <v-card-text>
                <h5>Total Impressions</h5>
                {{ this.facebookTotalsOnly.facebookImpressions }}
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6" sm="6" md="2" lg="2">
            <v-card>
              <v-card-text>
                <h5>Total Reach</h5>
                {{ this.facebookTotalsOnly.facebookReach }}
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6" sm="6" md="2" lg="2">
            <v-card>
              <v-card-text>
                <h5>Total Facebook Spend</h5>
                ZAR{{
                  this.facebookTotalsOnly.facebookSpend | formatTotalAmount
                }}
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6" sm="6" md="2" lg="2">
            <v-card>
              <v-card-text>
                <h5>Total Instagram Spend</h5>
                ZAR{{
                  this.instagramTotalsOnly.instagramSpend | formatTotalAmount
                }}
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6" sm="6" md="2" lg="2">
            <v-card>
              <v-card-text>
                <h5>Total Spend</h5>
                ZAR{{ this.adsFacebookTotals.total_spend | formatTotalAmount }}
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12">
            <v-divider class="mb-3"></v-divider>
            <h2>Averages</h2>
            <apexchart
              type="bar"
              height="350"
              :options="chartOptionsAdsAverages"
              :series="this.averages"
            >
            </apexchart>
          </v-col>
          <v-col cols="12">
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header color="primary" class="white--text">
                  View All Adsets
                </v-expansion-panel-header>
                <v-expansion-panel-content class="expanbg">
                  <v-row justify="center" align="center" class="pt-5">
                    <v-col
                      cols="12"
                      sm="12"
                      md="3"
                      lg="3"
                      v-for="adset in this.adsAdsets"
                      :key="adset.id"
                    >
                      <v-card min-height="200px">
                        <v-card-text>
                          <v-row>
                            <v-col cols="12" class="pb-0">
                              <h4 class="cardtitle">{{ adset.name }}</h4>
                              <!-- <p class="mb-0">
                                {{ adset.created_time | formatAdsetsDate }}
                              </p> -->
                              <v-divider></v-divider>
                            </v-col>
                            <v-col cols="4" class="px-1 py-2">
                              <v-card class="primary white--text">
                                <p class="mb-0 cardfont">Clicks</p>
                                <p class="mb-0">
                                  {{ adset.adsetTotalsFacebook.clicks }}
                                </p>
                              </v-card>
                            </v-col>
                            <v-col cols="4" class="px-1 py-2">
                              <v-card class="compeatsecondary white--text">
                                <p class="mb-0 cardfont">Impressions</p>
                                <p class="mb-0">
                                  {{ adset.adsetTotalsFacebook.impressions }}
                                </p>
                              </v-card>
                            </v-col>
                            <v-col cols="4" class="px-1 py-2">
                              <v-card class="thertiarty white--text">
                                <p class="mb-0 cardfont">Reach</p>
                                <p class="mb-0">
                                  {{ adset.adsetTotalsFacebook.reach }}
                                </p>
                              </v-card>
                            </v-col>
                            <v-col cols="12" class="py-0">
                              <v-divider class="mb-1"></v-divider>
                              <h4 v-if="adset.adsetTotalsFacebook.spend">
                                Spend: ZAR
                                {{
                                  adset.adsetTotalsFacebook.spend
                                    | formatTotalAmount
                                }}
                              </h4>
                              <h4 v-else>Spend: ZAR 0,00</h4>
                            </v-col>
                            <v-col cols="12" class="pt-0 pb-2">
                              <v-divider class="mt-1 mb-2"></v-divider>
                              <v-chip
                                color="success"
                                small
                                v-if="adset.status == 'ACTIVE'"
                                >{{ adset.status }}</v-chip
                              >
                            </v-col>
                          </v-row>
                        </v-card-text>
                        <v-card-actions>
                          <v-row>
                            <v-col cols="12" class="text-center">
                              <v-dialog
                                transition="dialog-bottom-transition"
                                fullscreen
                                hide-overlay
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    color="primary"
                                    rounded
                                    small
                                    v-bind="attrs"
                                    v-on="on"
                                    >View Insights</v-btn
                                  >
                                </template>
                                <template v-slot:default="dialog">
                                  <v-card>
                                    <v-toolbar color="primary" dark>
                                      <v-btn
                                        icon
                                        dark
                                        @click="dialog.value = false"
                                      >
                                        <v-icon>mdi-close</v-icon>
                                      </v-btn>
                                      <v-toolbar-title
                                        >Insights For
                                        {{ adset.name }}</v-toolbar-title
                                      >
                                    </v-toolbar>
                                    <v-card-text>
                                      <v-row
                                        class="py-5"
                                        justify="center"
                                        align="center"
                                      >
                                        <v-col cols="6">
                                          <h2 class="mb-3">Adset Overview</h2>
                                        </v-col>
                                        <v-col cols="6" class="text-right">
                                          <viewAds :ads="adset.ads.data" />
                                        </v-col>
                                        <v-col cols="12" sm="12" md="6" lg="6">
                                          <v-row>
                                            <v-col cols="12">
                                              <v-card class="px-2 py-2">
                                                <v-row>
                                                  <v-col cols="12" class="pb-0">
                                                    <h2>Ad Info & Settings</h2>
                                                  </v-col>
                                                  <v-col cols="12" class="pb-0">
                                                    <b>Account Name:</b>
                                                    {{ adset.name }}
                                                  </v-col>
                                                  <v-col
                                                    cols="12"
                                                    sm="12"
                                                    md="6"
                                                    lg="6"
                                                  >
                                                    <b>Start Date:</b>
                                                    Need Date
                                                  </v-col>
                                                  <v-col
                                                    cols="12"
                                                    sm="12"
                                                    md="6"
                                                    lg="6"
                                                  >
                                                    <b>End Date:</b>
                                                    Need Date
                                                  </v-col>
                                                  <v-col
                                                    cols="12"
                                                    sm="12"
                                                    md="6"
                                                    lg="6"
                                                    class="pt-0"
                                                  >
                                                    <b>Total Spend:</b>
                                                    ZAR
                                                    {{
                                                      adset.adsetTotalsFacebook
                                                        .spend
                                                        | formatTotalAmount
                                                    }}
                                                  </v-col>
                                                  <v-col cols="12">
                                                    <v-divider></v-divider>
                                                  </v-col>
                                                  <v-col cols="12" class="pt-0">
                                                    <h2>Ad Targeting</h2>
                                                  </v-col>
                                                  <v-col
                                                    cols="12"
                                                    sm="12"
                                                    md="6"
                                                    lg="6"
                                                  >
                                                    <b>Min Age:</b>
                                                    {{
                                                      adset.targeting.age_min
                                                    }}
                                                  </v-col>
                                                  <v-col
                                                    cols="12"
                                                    sm="12"
                                                    md="6"
                                                    lg="6"
                                                  >
                                                    <b>Max Age:</b>
                                                    {{
                                                      adset.targeting.age_max
                                                    }}
                                                  </v-col>
                                                </v-row>
                                              </v-card>
                                            </v-col>
                                          </v-row>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="6" lg="6">
                                          <h2 class="mb-3"></h2>
                                          <v-row>
                                            <v-col
                                              cols="12"
                                              sm="12"
                                              md="4"
                                              lg="4"
                                            >
                                              <v-card
                                                dark
                                                color="primary"
                                                class="px-2"
                                              >
                                                <v-row>
                                                  <v-col
                                                    cols="12"
                                                    class="text-center"
                                                  >
                                                    <b>Total Clicks</b>
                                                    <p class="mb-0">
                                                      {{
                                                        adset
                                                          .adsetTotalsFacebook
                                                          .clicks
                                                      }}
                                                    </p>
                                                  </v-col>
                                                </v-row>
                                              </v-card>
                                            </v-col>
                                            <v-col
                                              cols="12"
                                              sm="12"
                                              md="4"
                                              lg="4"
                                            >
                                              <v-card
                                                dark
                                                color="compeatsecondary"
                                                class="px-2"
                                              >
                                                <v-row>
                                                  <v-col
                                                    cols="12"
                                                    class="text-center"
                                                  >
                                                    <b>Total Impressions</b>
                                                    <p class="mb-0">
                                                      {{
                                                        adset
                                                          .adsetTotalsFacebook
                                                          .impressions
                                                      }}
                                                    </p>
                                                  </v-col>
                                                </v-row>
                                              </v-card>
                                            </v-col>
                                            <v-col
                                              cols="12"
                                              sm="12"
                                              md="4"
                                              lg="4"
                                            >
                                              <v-card
                                                dark
                                                color="compeatthird"
                                                class="px-2"
                                              >
                                                <v-row>
                                                  <v-col
                                                    cols="12"
                                                    class="text-center"
                                                  >
                                                    <b>Total Reach</b>
                                                    <p class="mb-0">
                                                      {{
                                                        adset
                                                          .adsetTotalsFacebook
                                                          .reach
                                                      }}
                                                    </p>
                                                  </v-col>
                                                </v-row>
                                              </v-card>
                                            </v-col>
                                            <v-col cols="12">
                                              <v-card class="px-2 py-2">
                                                <v-row>
                                                  <v-col cols="12" class="pb-0">
                                                    <h2>Costings</h2>
                                                  </v-col>
                                                  <v-col
                                                    cols="6"
                                                    sm="6"
                                                    md="3"
                                                    lg="3"
                                                  >
                                                    <b>CPC:</b>
                                                    {{
                                                      adset.costAverages.cpc
                                                        | toFixed2
                                                    }}
                                                  </v-col>
                                                  <v-col
                                                    cols="6"
                                                    sm="6"
                                                    md="3"
                                                    lg="3"
                                                  >
                                                    <b>CPM:</b>
                                                    {{
                                                      adset.costAverages.cpm
                                                        | toFixed2
                                                    }}
                                                  </v-col>
                                                  <v-col
                                                    cols="6"
                                                    sm="6"
                                                    md="3"
                                                    lg="3"
                                                  >
                                                    <b>CPP:</b>
                                                    {{
                                                      adset.costAverages.cpp
                                                        | toFixed2
                                                    }}
                                                  </v-col>
                                                  <v-col
                                                    cols="6"
                                                    sm="6"
                                                    md="3"
                                                    lg="3"
                                                  >
                                                    <b>CTR:</b>
                                                    {{
                                                      adset.costAverages.ctr
                                                        | toFixed2
                                                    }}
                                                  </v-col>
                                                  <v-col
                                                    cols="6"
                                                    sm="6"
                                                    md="3"
                                                    lg="3"
                                                  >
                                                    <b>CPIPE:</b>
                                                    {{
                                                      adset.costAverages
                                                        .cost_per_inline_post_engagement
                                                        | toFixed2
                                                    }}
                                                  </v-col>
                                                </v-row>
                                              </v-card>
                                            </v-col>
                                          </v-row>
                                        </v-col>
                                        <v-col cols="12">
                                          <v-divider></v-divider>
                                        </v-col>
                                        <v-col cols="12">
                                          <h2>Platform Breakdown</h2>
                                        </v-col>
                                        <v-col cols="12">
                                          <v-expansion-panels>
                                            <v-expansion-panel
                                              v-for="item in adset.facebookInsights"
                                              :key="item.id"
                                            >
                                              <v-expansion-panel-header>
                                                {{
                                                  item.platform_position
                                                    | transformTitle
                                                }}
                                                <v-spacer></v-spacer>
                                                {{ item.account_currency }}
                                                {{
                                                  item.spend | formatTotalAmount
                                                }}
                                              </v-expansion-panel-header>
                                              <v-expansion-panel-content>
                                                <v-row
                                                  justify="center"
                                                  align="center"
                                                >
                                                  <v-col
                                                    cols="12"
                                                    sm="12"
                                                    md="6"
                                                    lg="6"
                                                  >
                                                    <v-card class="px-2 py-2">
                                                      <v-row>
                                                        <v-col
                                                          cols="12"
                                                          class="pb-0"
                                                        >
                                                          <h2>
                                                            Ad Info & Settings
                                                          </h2>
                                                        </v-col>
                                                        <v-col
                                                          cols="12"
                                                          class="pb-0"
                                                        >
                                                          <b>Account Name:</b>
                                                          {{
                                                            item.account_name
                                                          }}
                                                        </v-col>
                                                        <v-col
                                                          cols="12"
                                                          sm="12"
                                                          md="6"
                                                          lg="6"
                                                        >
                                                          <b>Start Date:</b>
                                                          {{ item.date_start }}
                                                        </v-col>
                                                        <v-col
                                                          cols="12"
                                                          sm="12"
                                                          md="6"
                                                          lg="6"
                                                        >
                                                          <b>End Date:</b>
                                                          {{ item.date_stop }}
                                                        </v-col>
                                                        <v-col
                                                          cols="12"
                                                          sm="12"
                                                          md="6"
                                                          lg="6"
                                                          class="pt-0"
                                                        >
                                                          <b>Total Spend:</b>
                                                          {{
                                                            item.account_currency
                                                          }}
                                                          {{
                                                            item.spend
                                                              | formatTotalAmount
                                                          }}
                                                        </v-col>
                                                      </v-row>
                                                    </v-card>
                                                  </v-col>
                                                  <v-col>
                                                    <v-row>
                                                      <v-col
                                                        cols="12"
                                                        sm="12"
                                                        md="4"
                                                        lg="4"
                                                      >
                                                        <v-card
                                                          dark
                                                          color="primary"
                                                          class="px-2"
                                                        >
                                                          <v-row>
                                                            <v-col
                                                              cols="12"
                                                              class="text-center"
                                                            >
                                                              <b
                                                                >Total Clicks</b
                                                              >
                                                              <p class="mb-0">
                                                                {{
                                                                  item.clicks
                                                                }}
                                                              </p>
                                                            </v-col>
                                                          </v-row>
                                                        </v-card>
                                                      </v-col>
                                                      <v-col
                                                        cols="12"
                                                        sm="12"
                                                        md="4"
                                                        lg="4"
                                                      >
                                                        <v-card
                                                          dark
                                                          color="compeatsecondary"
                                                          class="px-2"
                                                        >
                                                          <v-row>
                                                            <v-col
                                                              cols="12"
                                                              class="text-center"
                                                            >
                                                              <b
                                                                >Total
                                                                Impressions</b
                                                              >
                                                              <p class="mb-0">
                                                                {{
                                                                  item.impressions
                                                                }}
                                                              </p>
                                                            </v-col>
                                                          </v-row>
                                                        </v-card>
                                                      </v-col>
                                                      <v-col
                                                        cols="12"
                                                        sm="12"
                                                        md="4"
                                                        lg="4"
                                                      >
                                                        <v-card
                                                          dark
                                                          color="compeatthird"
                                                          class="px-2"
                                                        >
                                                          <v-row>
                                                            <v-col
                                                              cols="12"
                                                              class="text-center"
                                                            >
                                                              <b>Total Reach</b>
                                                              <p class="mb-0">
                                                                {{ item.reach }}
                                                              </p>
                                                            </v-col>
                                                          </v-row>
                                                        </v-card>
                                                      </v-col>
                                                      <v-col
                                                        cols="12"
                                                        sm="12"
                                                        md="12"
                                                        lg="12"
                                                      >
                                                        <v-card
                                                          class="px-2 py-2"
                                                        >
                                                          <v-row>
                                                            <v-col
                                                              cols="12"
                                                              class="pb-0"
                                                            >
                                                              <h2>Costings</h2>
                                                            </v-col>
                                                            <v-col
                                                              cols="6"
                                                              sm="6"
                                                              md="3"
                                                              lg="3"
                                                            >
                                                              <b>CPC:</b>
                                                              {{
                                                                item.cpc
                                                                  | toFixed2
                                                              }}
                                                            </v-col>
                                                            <v-col
                                                              cols="6"
                                                              sm="6"
                                                              md="3"
                                                              lg="3"
                                                            >
                                                              <b>CPM:</b>
                                                              {{
                                                                item.cpm
                                                                  | toFixed2
                                                              }}
                                                            </v-col>
                                                            <v-col
                                                              cols="6"
                                                              sm="6"
                                                              md="3"
                                                              lg="3"
                                                            >
                                                              <b>CPP:</b>
                                                              {{
                                                                item.cpp
                                                                  | toFixed2
                                                              }}
                                                            </v-col>
                                                            <v-col
                                                              cols="6"
                                                              sm="6"
                                                              md="3"
                                                              lg="3"
                                                            >
                                                              <b>CTR:</b>
                                                              {{
                                                                item.ctr
                                                                  | toFixed2
                                                              }}
                                                            </v-col>
                                                            <v-col
                                                              cols="6"
                                                              sm="6"
                                                              md="3"
                                                              lg="3"
                                                            >
                                                              <b>CPIPE:</b>
                                                              {{
                                                                item.cost_per_inline_post_engagement
                                                                  | toFixed2
                                                              }}
                                                            </v-col>
                                                          </v-row>
                                                        </v-card>
                                                      </v-col>
                                                    </v-row>
                                                  </v-col>
                                                </v-row>
                                              </v-expansion-panel-content>
                                            </v-expansion-panel>
                                          </v-expansion-panels>
                                        </v-col>
                                      </v-row>
                                    </v-card-text>
                                  </v-card>
                                </template>
                              </v-dialog>
                            </v-col>
                          </v-row>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
      </v-container>
      <v-container v-else>
        <v-row>
          <v-col cols="12" class="text-center">
            <p class="mb-0">No Data</p>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div class="lightgrey" v-if="selectedSections.includes('audienceSection')">
      <v-container>
        <v-row>
          <v-col cols="12" class="my-6 text-center">
            <h1>Audience Overview</h1>
            <p>Quick glance at the Audience totals from the last 30 Days</p>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div v-if="selectedSections.includes('audienceSection')">
      <v-container>
        <v-row justify="center" align="center" class="text-center mt-2">
          <v-col cols="12">
            <h2>Cities Audience</h2>
            <apexchart
              type="bar"
              :options="chartOptionsDemographicsCitiesAudience"
              :series="demographicsCitiesAudience"
            ></apexchart>
          </v-col>
          <v-col cols="12">
            <h2>Cities Reach</h2>
            <apexchart
              type="bar"
              :options="chartOptionsDemographicsCitiesReach"
              :series="demographicsCitiesReach"
            ></apexchart>
          </v-col>
          <!-- <v-col cols="12" sm="12" md="6" lg="6">
            <v-card class="py-3 px-3">
              <h2>Gender Age Audience</h2>
              <apexchart
                type="donut"
                height="350"
                :options="chartOptionsDemographicsGenderAudience"
                :series="demographicsGenderAudience"
              >
              </apexchart>
            </v-card>
          </v-col> -->
          <v-col cols="12" sm="12" md="12" lg="12">
            <v-card class="py-3 px-3">
              <h2>Gender Age Reach</h2>
              <apexchart
                type="donut"
                height="350"
                :options="chartOptionsDemographicsGenderReach"
                :series="demographicsGenderReach"
              >
              </apexchart>
            </v-card>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6">
            <h2>Countries Audience</h2>
            <apexchart
              type="bar"
              :options="chartOptionsDemographicsCountriesAudience"
              :series="demographicsCountriesAudience"
            ></apexchart>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6">
            <h2>Countries Reach</h2>
            <apexchart
              type="bar"
              :options="chartOptionsDemographicsCountriesReach"
              :series="demographicsCountriesReach"
            ></apexchart>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6">
            <h2>Locales Audience</h2>
            <apexchart
              type="bar"
              :options="chartOptionsDemographicsLocalsAudience"
              :series="demographicsLocalesAudience"
            ></apexchart>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6">
            <h2>Locales Reach</h2>
            <apexchart
              type="bar"
              :options="chartOptionsDemographicsLocalsReach"
              :series="demographicsLocalesReach"
            ></apexchart>
          </v-col>
          <v-col cols="12">
            <v-divider class="mb-3"></v-divider>
            <h2>Followers Overview</h2>
          </v-col>
          <v-col cols="12" sm="12" md="12" lg="12">
            <v-card class="py-3 px-3">
              <!-- <h2>Followers Overall</h2> -->
              <apexchart
                height="350px"
                type="line"
                :options="chartOptionsOverallFollowers"
                :series="getOverAllFollowers"
              ></apexchart>
            </v-card>
          </v-col>
          <!-- <v-col cols="12" sm="12" md="6" lg="6">
            <v-card class="py-3 px-3">
              <h2>Total Followers</h2>
              <apexchart
                height="350px"
                type="line"
                :options="chartOptionsOverallFollowerss"
                :series="totalfollowersSeries"
              ></apexchart>
            </v-card>
          </v-col> -->
          <!-- <v-col cols="12">
            <v-card class="py-3 px-3">
              <h2>Followers Source</h2>
              <apexchart
                type="bar"
                height="350"
                :options="chartOptionsfollwersSource"
                :series="follwersSourceValues"
              ></apexchart>
            </v-card>
          </v-col> -->
          <v-col cols="12">
            <v-divider class="mb-3"></v-divider>
            <h2>Fans Online Overview</h2>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6">
            <h2>Fans Online Per Day</h2>
            <apexchart
              type="bar"
              :options="chartOptionsFansOnlinePerDay"
              :series="fansOnlinePerDayAudience"
            >
            </apexchart>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6">
            <h2>Fans Online Per Hour</h2>
            <apexchart
              type="bar"
              :options="chartOptionsFansOnlinePerHours"
              :series="fansOnlinePerHourAudience"
            >
            </apexchart>
          </v-col>
          <v-col cols="12">
            <v-divider class="mb-3"></v-divider>
            <h2>Page Views Overview</h2>
          </v-col>
          <!-- <v-col cols="12" sm="12" md="6" lg="6">
            <v-card class="py-3 px-3">
              <h2>Page Views By Age Gender</h2>
              <apexchart
                type="donut"
                height="350"
                :options="chartOptionsPageviewByGender"
                :series="pageViewByGenderAudience"
              >
              </apexchart>
            </v-card>
          </v-col> -->
          <!-- <v-col cols="12" sm="12" md="6" lg="6">
            <v-card class="py-3 px-3">
              <h2>Page Views By Referrer</h2>
              <apexchart
                type="donut"
                height="350"
                :options="chartOptionsPageviewByReferrer"
                :series="pageviewByReferrerAudience"
              >
              </apexchart>
            </v-card>
          </v-col> -->
          <!-- <v-col cols="12" sm="12" md="6" lg="6">
            <v-card class="py-3 px-3">
              <h2>Page Views By Device</h2>
              <apexchart
                type="donut"
                height="350"
                :options="chartOptionsPageviewBySite"
                :series="pageviewBySiteAudience"
              >
              </apexchart>
            </v-card>
          </v-col> -->
          <!-- <v-col cols="12" sm="12" md="6" lg="6">
            <v-card class="py-3 px-3">
              <h2>Page Views By Tab</h2>
              <apexchart
                type="donut"
                height="350"
                :options="chartOptionsPageviewByTab"
                :series="pageviewByTabAudience"
              >
              </apexchart>
            </v-card>
          </v-col> -->
          <v-col cols="12">
            <v-card class="py-3 px-3">
              <h2>Total Page View Daily</h2>
              <apexchart
                height="350px"
                type="line"
                :options="chartOptionsTotalPageview"
                :series="pageviewTotalDailyViews"
              ></apexchart>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div
      class="lightgrey"
      v-if="selectedSections.includes('engagementSection')"
    >
      <v-container>
        <v-row>
          <v-col cols="12" class="my-6 text-center">
            <h1>Engagment Overview</h1>
            <p>Quick glance at the Engagment totals from the last 30 Days</p>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div v-if="selectedSections.includes('engagementSection')">
      <v-container>
        <v-row justify="center" align="center" class="text-center mt-2">
          <!-- <v-col cols="12">
                            <h2>Clicks Overview</h2>
                        </v-col> -->
          <v-col cols="12">
            <h2>Clicks Overview</h2>
            <apexchart
              height="350px"
              type="line"
              :options="chartOptionsEngagmentClicks"
              :series="engagementClicks"
            ></apexchart>
          </v-col>
          <v-col cols="12">
            <v-divider class="mb-3"></v-divider>
            <h2>Likes Overview</h2>
          </v-col>
          <v-col cols="12" sm="12" md="12" lg="12">
            <h2>Likes Type</h2>
            <apexchart
              height="350px"
              type="line"
              :options="chartOptionsEngagmentClicks"
              :series="engagementLikesType"
            ></apexchart>
          </v-col>
          <!-- <v-col cols="12" sm="12" md="6" lg="6">
            <h2>Likes Source</h2>
            <apexchart
              height="350px"
              type="line"
              :options="chartOptionsEngagmentClicks"
              :series="engagementLikeSource"
            ></apexchart>
          </v-col> -->
          <v-col cols="12">
            <h2>Total Page Likes</h2>
            <apexchart
              height="350px"
              type="line"
              :options="chartOptionsEngagmentClicks"
              :series="totalPageLikes"
            ></apexchart>
          </v-col>
          <v-col cols="12">
            <v-divider class="mb-3"></v-divider>
            <h2>Feedback Overview</h2>
          </v-col>
          <v-col cols="12">
            <h2>Likes Source</h2>
            <apexchart
              height="350px"
              type="line"
              :options="chartOptionsEngagmentClicks"
              :series="engagementFeedback"
            ></apexchart>
          </v-col>
          <v-col cols="12">
            <v-divider class="mb-3"></v-divider>
            <h2>Checkins Overview</h2>
          </v-col>
          <v-col cols="12">
            <h2>Daily Check Ins</h2>
            <apexchart
              height="350px"
              type="line"
              :options="chartOptionsEngagmentClicks"
              :series="engagementCheckIns"
            ></apexchart>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div class="lightgrey" v-if="selectedSections.includes('reachSection')">
      <v-container>
        <v-row>
          <v-col cols="12" class="my-6 text-center">
            <h1>Reach Overview</h1>
            <p>Quick glance at the Reach totals from the last 30 Days</p>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div v-if="selectedSections.includes('reachSection')">
      <v-container>
        <v-row justify="center" align="center" class="text-center mt-2">
          <v-col cols="12">
            <h2>Total Page Impressions</h2>
            <apexchart
              height="350px"
              type="line"
              :options="chartOptionsReachLineCharts"
              :series="reachImpressionsOrganic"
            ></apexchart>
          </v-col>
          <v-col cols="12">
            <h2>Total Page Impressions Unique</h2>
            <apexchart
              height="350px"
              type="line"
              :options="chartOptionsReachLineCharts"
              :series="reachImpressionsOrganicUnique"
            ></apexchart>
          </v-col>
          <v-col cols="12">
            <apexchart
              type="bar"
              :options="chartOptionsImpressionsStoryType"
              :series="reachImpressionsAndOrganic"
            >
            </apexchart>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div class="lightgrey" v-if="selectedSections.includes('videoSection')">
      <v-container>
        <v-row>
          <v-col cols="12" class="my-6 text-center">
            <h1>Video Overview</h1>
            <p>Quick glance at the Audience totals from the last 30 Days</p>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div v-if="selectedSections.includes('videoSection')">
      <v-container>
        <v-row justify="center" align="center" class="text-center mt-2">
          <v-col cols="6" sm="6" md="2" lg="2">
            <v-card>
              <v-card-text>
                <h4>Total View Time</h4>
                {{ this.totalVideoView }}
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6" sm="6" md="2" lg="2">
            <v-card>
              <v-card-text>
                <h4>Total Organic Views</h4>
                {{ this.totalVideoOrganic }}
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6" sm="6" md="2" lg="2">
            <v-card>
              <v-card-text>
                <h4>Total Paid Views</h4>
                {{ this.totalVideoPaid }}
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6" sm="6" md="2" lg="2">
            <v-card>
              <v-card-text>
                <h4>Total Auto Play</h4>
                {{ this.totalVideoViewSourceAutoPlay }}
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6" sm="6" md="2" lg="2">
            <v-card>
              <v-card-text>
                <h4>Total Click To Play</h4>
                {{ this.totalVideoViewSourceClickToPlay }}
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12">
            <h2>Total Video Views Overall</h2>
            <apexchart
              height="350px"
              type="line"
              :options="chartOptionsVideoOverall"
              :series="videoViewsOverall"
            ></apexchart>
          </v-col>
          <!-- <v-col cols="12">
            <h2>Total Video Views Ten Sec</h2>
            <apexchart
              height="350px"
              type="line"
              :options="chartOptionsVideoOverall"
              :series="videoViewsTenSec"
            ></apexchart>
          </v-col> -->
          <v-col cols="12">
            <h2>Total Video Views Thirty Sec</h2>
            <apexchart
              height="350px"
              type="line"
              :options="chartOptionsVideoOverall"
              :series="videoViewsThrithySec"
            ></apexchart>
          </v-col>
          <v-col cols="12">
            <h2>Auto Play And Clicks To Play Overview</h2>
            <apexchart
              height="350px"
              type="line"
              :options="chartOptionsClickAndAutoPlay"
              :series="autoAndClickViews"
            ></apexchart>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="120"
        >Please Wait...</v-progress-circular
      >
    </v-overlay>
  </div>
</template>

<script>
import donutChart from "@/components/charts/donutChart.vue";
import lineChart from "@/components/charts/lineChart.vue";
import barChartHorizontal from "../components/charts/barChartHorizontal.vue";
import viewAds from "../components/dialogs/viewAds.vue";
import { firebaseApp } from "../firebaseConfig";
import { getFirestore, doc, getDoc } from "firebase/firestore";
const db = getFirestore(firebaseApp);
import { getAuth, onAuthStateChanged } from "firebase/auth";
import moment from "moment-timezone";

export default {
  props: ["id", "uid", "reportId"],
  components: {
    donutChart,
    lineChart,
    barChartHorizontal,
    viewAds,
  },
  data: () => ({
    isLoggedInUser: false,
    selectedInsightsReport: "",
    campaignsSection: true,

    selectSections: [
      { name: "Campaigns Section", value: "campaignsSection" },
      { name: "Posts Section", value: "postsSection" },
      { name: "Ads Section", value: "adsSection" },
      { name: "Audience Section", value: "audienceSection" },
      { name: "Engagement Section", value: "engagementSection" },
      { name: "Reach Section", value: "reachSection" },
      { name: "Video Section", value: "videoSection" },
    ],
    selectedSections: [
      "campaignsSection",
      "postsSection",
      "adsSection",
      "engagementSection",
      "audienceSection",
      "reachSection",
      "videoSection",
    ],
    menuOpen: false,
    ads: [],
    campaigns: [],
    engagement: [],
    audience: [],
    posts: [],
    postsTotals: [],
    reach: [],
    video: [],
    absolute: true,
    opacity: 1,
    overlay: false,
    title: "",

    ageGroupSeries: [],
    options: [],

    adsHeadings: [],
    adsValues: [],
    averages: [],
    chartOptionsAdsAverages: {},
    chartOptionsByGender: {},
    chartOptionsTotalsByGender: {},
    chartOptionsSpendByGender: {},
    chartOptionsOverallFollowers: {},
    chartOptionsOverallFollowerss: {},
    chartOptionsfollwersSource: {},
    chartOptionsEngagmentClicks: {},
    chartOptionsDemographicsCitiesAudience: {},
    chartOptionsDemographicsCitiesReach: {},
    chartOptionsDemographicsCountriesAudience: {},
    chartOptionsDemographicsCountriesReach: {},
    chartOptionsDemographicsGenderAudience: {},
    chartOptionsDemographicsGenderReach: {},
    chartOptionsDemographicsLocalsAudience: {},
    chartOptionsDemographicsLocalsReach: {},
    chartOptionsFansOnlinePerDay: {},
    chartOptionsFansOnlinePerHours: {},
    chartOptionsPageviewByGender: {},
    chartOptionsPageviewByReferrer: {},
    chartOptionsPageviewBySite: {},
    chartOptionsPageviewByTab: {},
    chartOptionsTotalPageview: {},
    chartOptionsReachLineCharts: {},
    chartOptionsVideoOverall: {},
    chartOptionsClickAndAutoPlay: {},
    chartOptionsImpressionsStoryType: {},

    getOverAllFollowers: [],
    totalfollowersSeries: [],
    follwersSourceValues: [],
    performanceByPlacement: [],
    allCampaignsInsightsData: [],
    engagementClicks: [],
    engagementLikesType: [],
    engagementLikeSource: [],
    totalPageLikes: [],
    engagementFeedback: [],
    engagementCheckIns: [],
    demographicsCitiesAudience: [],
    demographicsCitiesReach: [],
    demographicsCountriesAudience: [],
    demographicsCountriesReach: [],
    demographicsGenderAudience: [],
    demographicsGenderReach: [],
    demographicsLocalesAudience: [],
    demographicsLocalesReach: [],
    fansOnlinePerDayAudience: [],
    fansOnlinePerHourAudience: [],
    pageViewByGenderAudience: [],
    pageviewByReferrerAudience: [],
    pageviewBySiteAudience: [],
    pageviewByTabAudience: [],
    pageviewTotalDailyViews: [],
    reachImpressionsOrganic: [],
    reachImpressionsOrganicUnique: [],
    reachStoryTypeImpressions: [],
    reachStoryTypeImpressionsUnique: [],
    videoViewsOverall: [],
    videoViewsTenSec: [],
    videoViewsThrithySec: [],
    autoAndClickViews: [],
    reachImpressionsAndOrganic: [],

    totalVideoView: "",
    totalVideoOrganic: "",
    totalVideoPaid: "",
    totalVideoViewSourceAutoPlay: "",
    totalVideoViewSourceClickToPlay: "",

    campaignsFacebookTotals: [],
    campaignsInstagramTotals: [],
    campaignsTotals: [],
    adsFacebookTotals: [],
    facebookTotalsOnly: [],
    instagramTotalsOnly: [],
    adsAdsets: [],

    headers: [
      {
        text: "Platform Name",
        align: "center",
        sortable: false,
        value: "name",
      },
      { text: "Clicks", align: "center", value: "clicks", sortable: false },
      {
        text: "Impressions",
        align: "center",
        value: "impressions",
        sortable: false,
      },
      { text: "Reach", align: "center", value: "reach", sortable: false },
      { text: "Spend", align: "center", value: "spend" },
      // { text: 'Protein (g)', value: 'protein' },
      // { text: 'Iron (%)', value: 'iron' },
    ],
    activeSubscription: false,
    pausedSubscription:false,
    cancelledSubscription:false,
    totalsByGenderSeries: [],
    totalGenderSpendSeries: [],
    chartOptionsTotalsByAge: {},
    chartOptionsSpendByAge: {},
    totalsByAgeSeries: [],
    totalAgeSpendSeries: [],
    noGenderData: false,
  }),
  created() {
    this.getCurrentUser();
  },
  filters: {
    transformTitle(value) {
      return value
        .split("_")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    },
    formatNumber(value) {
      return value.toFixed(2);
    },
    toFixed2(value) {
      if (!value) return "";
      return Number(value).toFixed(2);
    },
    formatTotalAmount: function (value) {
      if (!value) return "";
      return new Intl.NumberFormat("en-ZA", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    },
    formatAdsetsDate: function (value) {
      if (!value) return "";
      return moment(value).format("DD MMMM YYYY");
    },
  },
  computed: {
    filteredAdsets() {
      return this.ads.adsets.filter((adset) => {
        if (
          adset.ads.data.length > 0 &&
          adset.ads.data[0].creative.object_type.indexOf(
            "PRIVACY_CHECK_FAIL"
          ) === -1
        ) {
          return true;
        }
        return false;
      });
    },
  },
  methods: {
    // toggleSection(sectionValue) {
    //     // this.sectionValue != this.sectionValue
    //     console.log(sectionValue)
    // },
    getCurrentUser() {
      this.overlay = true;
      const auth = getAuth();
      onAuthStateChanged(auth, (user) => {
        if (user) {
          const getdata = async () => {
            const docRef = doc(db, "users", user.uid);
            const docSnap = await getDoc(docRef);
            let userRole = docSnap.data().userType;
            if (
              userRole == "SMM" ||
              userRole == "AA" ||
              userRole == "SB" ||
              userRole == "SA"
            ) {
              this.isLoggedInUser = true;
            }
          };
          getdata();
          this.getSubscription();
        } else {
          this.noUser = true;
          this.getSubscription();
        }
      });
    },
    async getSubscription() {
      try {
        const docRef = doc(db, "subscriptions", this.uid); // Use doc() to create a reference to the document
        const docSnapshot = await getDoc(docRef); // Use getDoc() to retrieve the document snapshot

        if (docSnapshot.exists()) {
          this.activeSubscription = true;
          this.selectedSubscription = docSnapshot.data();
          this.pagesLength = this.selectedSubscription.package.pages.length;

          if (this.pagesLength > 40) {
            this.height = "2000px";
          } else if (this.pagesLength > 30) {
            this.height = "1700px";
          } else if (this.pagesLength > 20) {
            this.height = "1300px";
          } else if (this.pagesLength > 10) {
            this.height = "900px";
          } else if (this.pagesLength > 5) {
            this.height = "400px";
          }
        } else {
          const cancelledSubscriptionDocRef = doc(db, "cancelledsubscriptions", this.uid);
          const cancelledSubscriptionSnapshot = await getDoc(cancelledSubscriptionDocRef);
          if (cancelledSubscriptionSnapshot.exists()) {
            this.cancelledSubscription = true;
            this.selectedSubscription = cancelledSubscriptionSnapshot.data();
          } else {
            const pausedSubscriptionDocRef = doc(db, "pausedsubscriptions", this.uid);
            const pausedSubscriptionSnapshot = await getDoc(pausedSubscriptionDocRef);
            if (pausedSubscriptionSnapshot.exists()) {
              this.pausedSubscription = true;
              this.selectedSubscription = pausedSubscriptionSnapshot.data();
            } else {
              this.overlay = false
              throw new Error("Document not found");
            }
          }
        }
        this.getReport();
      } catch (err) {
        console.log("err", err);
      }
    },
    async getReport() {
      try {
        const docRef = doc(db, "insightsReports", this.reportId); // Use doc() to create a reference to the document
        const docSnapshot = await getDoc(docRef); // Use getDoc() to retrieve the document snapshot

        if (!docSnapshot.exists()) {
          throw new Error("Document not found");
        }
        this.selectedInsightsReport = docSnapshot.data();

        if (
          this.selectedInsightsReport.adsets &&
          this.selectedInsightsReport.campaigns
        ) {
          //working Fine
          this.ads = this.selectedInsightsReport.adsets.adsets;
          this.adsFacebookTotals =
            this.selectedInsightsReport.adsets.adsets.totals;

          this.facebookTotalsOnly = this.ads.facebookTotals;
          this.instagramTotalsOnly = this.ads.instagramTotals;

          let adsAdsetsOverall =
            this.selectedInsightsReport.adsets.adsets.adsetsOverall;

          let adsAdsetsPlatform =
            this.selectedInsightsReport.adsets.adsets.adsetsPlatform;

          // Check if both arrays have the same length
          if (adsAdsetsOverall.length !== adsAdsetsPlatform.length) {
            console.error("Arrays must have the same length to join by index.");
            return;
          }

          // Join the arrays based on their indices
          this.adsAdsets = adsAdsetsOverall.map((value, index) => {
            return { ...value, ...adsAdsetsPlatform[index] };
          });

          this.campaigns = this.selectedInsightsReport.campaigns.campaigns;
          this.campaignsFacebookTotals =
            this.selectedInsightsReport.campaigns.campaigns.facebookTotals;
          this.campaignsInstagramTotals =
            this.selectedInsightsReport.campaigns.campaigns.instagramTotals;
          this.campaignsTotals =
            this.selectedInsightsReport.campaigns.campaigns.totals;

          this.posts = this.selectedInsightsReport.posts.posts;
          this.postsTotals = this.selectedInsightsReport.posts.posts.totals;

          this.engagement = this.selectedInsightsReport.engagement.engagment;
          this.audience = this.selectedInsightsReport.audience.audience;
          this.reach = this.selectedInsightsReport.reach.reach;
          this.video = this.selectedInsightsReport.video.video;

          this.getAdsAverages();
        } else {
          this.campaigns = null;
          this.ads = null;
          this.posts = this.selectedInsightsReport.posts.posts;
          this.postsTotals = this.selectedInsightsReport.posts.posts.totals;

          this.engagement = this.selectedInsightsReport.engagement.engagment;
          this.audience = this.selectedInsightsReport.audience.audience;
          this.reach = this.selectedInsightsReport.reach.reach;
          this.video = this.selectedInsightsReport.video.video;
          this.getEngagmentClicks();
        }

        // console.log(this.ads);
      } catch (err) {
        console.log("err", err);
      }
    },
    getAdsAverages() {
      this.adsHeadings = [];
      this.adsValues = [];

      // Loop through each key in the object
      for (const key in this.ads.averages) {
        if (this.ads.averages.hasOwnProperty(key)) {
          const modifiedKey = key.includes("average_")
            ? key.replace("average_", "")
            : key;
          this.adsHeadings.push(modifiedKey);
          const value = parseFloat(this.ads.averages[key]);
          this.adsValues.push(Number(value.toFixed(2)));
        }
      }
      this.averages = [
        {
          data: this.adsValues,
        },
      ];

      this.chartOptionsAdsAverages = {
        chart: {
          height: 350,
          events: {
            click: function (chart, w, e) {},
          },
        },
        plotOptions: {
          bar: {
            columnWidth: "45%",
            distributed: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        xaxis: {
          categories: this.adsHeadings,
          labels: {
            style: {
              fontSize: "12px",
            },
          },
        },
      };

      this.getClickByAgeAndGender();
    },
    getClickByAgeAndGender() {
      let dataByGender = this.campaigns.statsByGender;
      let dataByAge = this.campaigns.statByAge;

      if (dataByGender.female && dataByGender.male && dataByGender.unknown) {
        const labelsGender = ["female", "male", "unknown"];
        const seriesGender = ["clicks", "impressions", "reach"].map(
          (property) => {
            return {
              name: property,
              data: labelsGender.map(
                (label) => dataByGender?.[label]?.[property] || 0
              ),
            };
          }
        );
        const spendArray = labelsGender.map(
          (label) => dataByGender?.[label]?.spend || 0
        );

        const labelsAge = ["18-24", "25-34", "35-44", "45-54", "55-64", "65+"];
        const seriesAge = ["clicks", "impressions", "reach"].map((property) => {
          return {
            name: property,
            data: labelsAge.map((label) => dataByAge?.[label]?.[property] || 0),
          };
        });
        const spendArrayAge = labelsAge.map(
          (label) => dataByAge?.[label]?.spend || 0
        );

        this.totalsByGenderSeries = seriesGender;
        this.totalGenderSpendSeries = spendArray;

        this.totalsByAgeSeries = seriesAge;
        this.totalAgeSpendSeries = spendArrayAge;

        this.chartOptionsTotalsByGender = {
          chart: {
            type: "bar",
            height: 350,
            stacked: true,
          },
          plotOptions: {
            bar: {
              horizontal: true,
            },
          },
          stroke: {
            width: 1,
            colors: ["#fff"],
          },
          xaxis: {
            categories: labelsGender,
            labels: {
              formatter: function (val) {
                const formattedVal = val
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                return formattedVal + "K";
              },
            },
          },
          yaxis: {
            title: {
              text: undefined,
            },
          },
          tooltip: {
            y: {
              formatter: function (val) {
                const formattedVal = val
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                return formattedVal;
              },
            },
          },
          fill: {
            opacity: 1,
          },
          legend: {
            position: "top",
            horizontalAlign: "left",
            offsetX: 40,
          },
        };

        this.chartOptionsSpendByGender = {
          labels: labelsGender,
          dataLabels: {
            enabled: false,
          },
          tooltip: {
            y: {
              formatter: function (val) {
                const formattedVal = new Intl.NumberFormat("en-ZA", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }).format(val);
                return "ZAR " + formattedVal;
              },
            },
          },
          responsive: [
            {
              breakpoint: 960,
              options: {
                chart: {
                  width: 290,
                },
                legend: {
                  show: true,
                },
              },
            },
          ],
          legend: {
            position: "bottom",
          },
        };

        this.chartOptionsTotalsByAge = {
          chart: {
            type: "bar",
            height: 350,
            stacked: true,
          },
          plotOptions: {
            bar: {
              horizontal: true,
            },
          },
          stroke: {
            width: 1,
            colors: ["#fff"],
          },
          xaxis: {
            categories: labelsAge,
            labels: {
              formatter: function (val) {
                const formattedVal = val
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                return formattedVal + "K";
              },
            },
          },
          yaxis: {
            title: {
              text: undefined,
            },
          },
          tooltip: {
            y: {
              formatter: function (val) {
                const formattedVal = val
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                return formattedVal;
              },
            },
          },
          fill: {
            opacity: 1,
          },
          legend: {
            position: "top",
            horizontalAlign: "left",
            offsetX: 40,
          },
        };

        this.chartOptionsSpendByAge = {
          labels: labelsAge,
          dataLabels: {
            enabled: false,
          },
          tooltip: {
            y: {
              formatter: function (val) {
                const formattedVal = new Intl.NumberFormat("en-ZA", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }).format(val);
                return "ZAR " + formattedVal;
              },
            },
          },
          responsive: [
            {
              breakpoint: 960,
              options: {
                chart: {
                  width: 290,
                },
                legend: {
                  show: true,
                },
              },
            },
          ],
          legend: {
            position: "bottom",
          },
        };
      } else {
        this.noGenderData = true;
      }

      this.getPerformanceBy();
    },
    processArrayData(data) {
      const labels = Object.keys(data);
      const dataArray = [];
      const spendArray = [];

      labels.forEach((label) => {
        const item = data[label];
        const processedItem = this.processItem(item);
        dataArray.push({ name: label, ...processedItem });
        spendArray.push(processedItem.spend); // Add spend to spendArray
      });

      return { dataArray, spendArray, labels };
    },
    processItem(item) {
      return {
        data: [item.clicks, item.impressions, item.reach],
        spend: parseFloat(
          new Intl.NumberFormat("en-ZA", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
            useGrouping: false,
          }).format(item.spend)
        ),
      };
    },
    processGenderData(data) {
      const labels = Object.keys(data);
      const clicksArray = [];
      const impressionsArray = [];
      const reachArray = [];
      const totalSpendSeries = [];

      labels.forEach((label) => {
        clicksArray.push(data[label].clicks);
        impressionsArray.push(data[label].impressions);
        reachArray.push(data[label].reach);

        // Format spend using Intl.NumberFormat with a period as decimal separator
        const formattedSpend = new Intl.NumberFormat("en-ZA", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
          useGrouping: false, // Disable grouping (thousands separator)
        }).format(data[label].spend);

        // Convert formatted spend back to a number
        const spendAsNumber = parseFloat(formattedSpend);

        totalSpendSeries.push(spendAsNumber);
      });

      return {
        totalSpendSeries,
        seriesTotals: [
          {
            name: "Clicks",
            data: clicksArray,
          },
          {
            name: "Impressions",
            data: impressionsArray,
          },
          {
            name: "Reach",
            data: reachArray,
          },
        ],
        labels,
      };
    },
    getPerformanceBy() {
      let arr = this.campaigns.performanceByPlacement;

      this.performanceByPlacement = Object.entries(arr)
        .filter(([name]) => !name.includes("instagram"))
        .map(([name, data]) => {
          // Remove "facebook" substring and underscores
          let modifiedName = name.replace(/facebook|_/gi, " ");

          // Add spaces between words
          modifiedName = modifiedName.replace(/([a-z])([A-Z])/g, "$1 $2");
          modifiedName = modifiedName.replace(/([A-Z])([A-Z][a-z])/g, "$1 $2");

          // Capitalize the first letter of each word
          modifiedName = modifiedName.replace(/\b\w/g, function (l) {
            return l.toUpperCase();
          });

          return { name: modifiedName, ...data };
        });

      this.getEngagmentClicks();
    },
    getEngagmentClicks() {
      let engagementType = this.engagement.clicks.consumptions;

      this.engagementClicks = [
        {
          name: "Link Clicks",
          data: engagementType.link_clicks,
        },
        {
          name: "Other Clicks",
          data: engagementType.other_clicks,
        },
        {
          name: "Photo Clicks",
          data: engagementType.photo_view,
        },
        {
          name: "Video Clicks",
          data: engagementType.video_play,
        },
      ];

      this.chartOptionsEngagmentClicks = {
        chart: {
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: this.engagement.feedBack.dates,
        },
      };

      let likeType = this.engagement.likes;

      this.engagementLikesType = [
        {
          name: "paid",
          data: likeType.likes_type.paid,
        },
        {
          name: "organic",
          data: likeType.likes_type.unpaid,
        },
        {
          name: "lost",
          data: likeType.unlikes_per_day,
        },
      ];

      let likeSource = this.engagement.likes.likes_source;

      this.engagementLikeSource = [
        {
          name: "Your Page",
          data: likeSource.your_page,
        },
        {
          name: "Page Suggestions",
          data: likeSource.page_suggestions,
        },
        {
          name: "Restored",
          data: likeSource.restored,
        },
        {
          name: "Other",
          data: likeSource.other,
        },
      ];

      let totalLikes = this.engagement.likes.total_page_likes;

      this.totalPageLikes = [
        {
          name: "Total Page Likes",
          data: totalLikes,
        },
      ];

      this.engagementFeedback = [
        {
          name: "Like",
          data: this.engagement.feedBack.like,
        },
        {
          name: "Comment",
          data: this.engagement.feedBack.comment,
        },
        {
          name: "Link",
          data: this.engagement.feedBack.link,
        },
        {
          name: "Negative",
          data: this.engagement.feedBack.negative,
        },
        {
          name: "Other",
          data: this.engagement.feedBack.other,
        },
      ];

      this.engagementCheckIns = [
        {
          name: "Daily Check In's",
          data: this.engagement.checkIns.dailyCheckIns,
        },
      ];

      this.getAllFollowers();
    },
    getAllFollowers() {
      this.totalfollowersSeries = [
        {
          name: "Total Followers",
          data: this.audience.followers.overall_followers,
        },
      ];

      (this.chartOptionsOverallFollowerss = {
        chart: {
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: this.audience.followers.dates,
        },
      }),
        //Followers Source Line Graph
        (this.follwersSourceValues = [
          {
            data: this.audience.followers.follower_source.series,
          },
        ]);

      this.chartOptionsfollwersSource = {
        chart: {
          height: 350,
          events: {
            click: function (chart, w, e) {},
          },
        },
        plotOptions: {
          bar: {
            columnWidth: "45%",
            distributed: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        xaxis: {
          categories: this.audience.followers.follower_source.labels,
          labels: {
            style: {
              fontSize: "12px",
            },
          },
        },
      };

      this.getOverAllFollowers = [
        {
          name: "paid",
          data: this.audience.followers.followers_type.paid,
        },
        {
          name: "organic",
          data: this.audience.followers.followers_type.organic,
        },
        {
          name: "lost",
          data: this.audience.followers.followers_type.lost,
        },
      ];

      this.getAudienceDemographics();
    },
    getAudienceDemographics() {
      let citesAudience = this.audience.demographics.cities.audience;
      let citesReach = this.audience.demographics.cities.reach;
      let countryAudience = this.audience.demographics.countries.audience;
      let countryReach = this.audience.demographics.countries.reach;
      let genderAgeAudience = this.audience.demographics.gender_age.audience;
      let genderAgeReach = this.audience.demographics.gender_age.reach;
      let localesAudience = this.audience.demographics.locales.audience;
      let localesReach = this.audience.demographics.locales.reach;

      let audienceDemographicsCitiesValues = Object.values(citesAudience);
      let audienceDemographicsCitiesLables = Object.keys(citesAudience);

      let reachDemographicsCitiesValues = Object.values(citesReach);
      let reachDemographicsCitiesLables = Object.keys(citesReach);

      let audienceDemographicsCountriesValues = Object.values(countryAudience);
      let audienceDemographicsCountriesLables = Object.keys(countryAudience);

      let reachDemographicsCountriesValues = Object.values(countryReach);
      let reachDemographicsCountriesLables = Object.keys(countryReach);

      this.demographicsGenderAudience = Object.values(genderAgeAudience);
      let audienceDemographicsGenderLables = Object.keys(genderAgeAudience);

      this.demographicsGenderReach = Object.values(genderAgeReach);
      let reachDemographicsGenderLables = Object.keys(genderAgeReach);

      let audienceDemographicsLocalesValues = Object.values(localesAudience);
      let audienceDemographicsLocalesLabels = Object.keys(localesAudience);

      let reachDemographicsLocalesValues = Object.values(localesReach);
      let reachDemographicsLocalesLabels = Object.keys(localesReach);

      this.demographicsCitiesAudience = [
        {
          name: "Cites Audience",
          data: audienceDemographicsCitiesValues,
        },
      ];

      this.demographicsCitiesReach = [
        {
          name: "Cites Reach",
          data: reachDemographicsCitiesValues,
        },
      ];

      this.demographicsCountriesAudience = [
        {
          name: "Countries Audience",
          data: audienceDemographicsCountriesValues,
        },
      ];

      this.demographicsCountriesReach = [
        {
          name: "Countries Reach",
          data: reachDemographicsCountriesValues,
        },
      ];

      this.demographicsLocalesAudience = [
        {
          name: "Locales Audience",
          data: audienceDemographicsLocalesValues,
        },
      ];

      this.demographicsLocalesReach = [
        {
          name: "Locales Reach",
          data: reachDemographicsLocalesValues,
        },
      ];

      this.chartOptionsDemographicsCitiesAudience = {
        chart: {
          height: 500,
          events: {
            click: function (chart, w, e) {},
          },
        },
        plotOptions: {
          bar: {
            distributed: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        xaxis: {
          categories: audienceDemographicsCitiesLables,
          labels: {
            style: {
              fontSize: "8px",
            },
          },
        },
      };
      this.chartOptionsDemographicsCitiesReach = {
        chart: {
          height: 500,
          events: {
            click: function (chart, w, e) {},
          },
        },
        plotOptions: {
          bar: {
            distributed: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        xaxis: {
          categories: reachDemographicsCitiesLables,
          labels: {
            style: {
              fontSize: "8px",
            },
          },
        },
      };
      this.chartOptionsDemographicsCountriesAudience = {
        chart: {
          height: 800,
          events: {
            click: function (chart, w, e) {},
          },
        },
        plotOptions: {
          bar: {
            distributed: true,
            horizontal: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        xaxis: {
          categories: audienceDemographicsCountriesLables,
          labels: {
            style: {
              fontSize: "8px",
            },
          },
        },
      };
      this.chartOptionsDemographicsCountriesReach = {
        chart: {
          height: 800,
          events: {
            click: function (chart, w, e) {},
          },
        },
        plotOptions: {
          bar: {
            distributed: true,
            horizontal: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        xaxis: {
          categories: reachDemographicsCountriesLables,
          labels: {
            style: {
              fontSize: "8px",
            },
          },
        },
      };
      this.chartOptionsDemographicsGenderAudience = {
        labels: audienceDemographicsGenderLables,
        dataLabels: {
          enabled: false,
        },
        responsive: [
          {
            breakpoint: 960,
            options: {
              chart: {
                width: 290,
              },
              legend: {
                show: true,
              },
            },
          },
        ],
        legend: {
          position: "bottom",
        },
      };
      this.chartOptionsDemographicsGenderReach = {
        labels: reachDemographicsGenderLables,
        dataLabels: {
          enabled: false,
        },
        responsive: [
          {
            breakpoint: 960,
            options: {
              chart: {
                width: 290,
              },
              legend: {
                show: true,
              },
            },
          },
        ],
        legend: {
          position: "bottom",
        },
      };
      this.chartOptionsDemographicsLocalsAudience = {
        chart: {
          height: 800,
          events: {
            click: function (chart, w, e) {},
          },
        },
        plotOptions: {
          bar: {
            distributed: true,
            horizontal: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        xaxis: {
          categories: audienceDemographicsLocalesLabels,
          labels: {
            style: {
              fontSize: "8px",
            },
          },
        },
      };
      this.chartOptionsDemographicsLocalsReach = {
        chart: {
          height: 800,
          events: {
            click: function (chart, w, e) {},
          },
        },
        plotOptions: {
          bar: {
            distributed: true,
            horizontal: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        xaxis: {
          categories: reachDemographicsLocalesLabels,
          labels: {
            style: {
              fontSize: "8px",
            },
          },
        },
      };

      this.getAudienceFansOnline();
    },
    getAudienceFansOnline() {
      let fansDates = this.audience.fansOnline.dates;
      let fansOnlinePerDay = this.audience.fansOnline.fans_online_per_day;
      let fansOnlinePerHour = this.audience.fansOnline.fans_online_per_hour;

      let hours = Object.keys(fansOnlinePerHour).map((hour) => hour + " hour");
      let fansOnlinePerHourValues = Object.values(fansOnlinePerHour);

      this.fansOnlinePerDayAudience = [
        {
          name: "Total Fans Online Per Day",
          data: fansOnlinePerDay,
        },
      ];

      this.fansOnlinePerHourAudience = [
        {
          name: "Total Fans Online Per Hour",
          data: fansOnlinePerHourValues,
        },
      ];

      this.chartOptionsFansOnlinePerDay = {
        chart: {
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: fansDates,
        },
      };

      this.chartOptionsFansOnlinePerHours = {
        chart: {
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: hours,
        },
      };

      this.getAudiencePageviews();
    },
    getAudiencePageviews() {
      let pageviewByGender = this.audience.pageViews.page_views_by_age_gender;
      let pageviewByReferrer = this.audience.pageViews.page_views_by_referrer;
      let pageviewBySite = this.audience.pageViews.page_views_by_site;
      let pageviewByTab = this.audience.pageViews.page_views_by_tab;
      let totalPageView = this.audience.pageViews.total_page_views_daily;

      let pageviewByGenderLabels = Object.keys(pageviewByGender);
      this.pageViewByGenderAudience = Object.values(pageviewByGender);

      let pageviewByReferrerLables = Object.keys(pageviewByReferrer);
      this.pageviewByReferrerAudience = Object.values(pageviewByReferrer);

      let pageviewBySiteLables = Object.keys(pageviewBySite);
      this.pageviewBySiteAudience = Object.values(pageviewBySite);

      let pageviewByTabLables = Object.keys(pageviewByTab);
      this.pageviewByTabAudience = Object.values(pageviewByTab);

      let pageviewTotalViewDailyLables = Object.keys(totalPageView);
      let pageviewTotalViewDailyAudience = Object.values(totalPageView);

      this.pageviewTotalDailyViews = [
        {
          name: "Total Page View Per Day",
          data: pageviewTotalViewDailyAudience,
        },
      ];

      this.chartOptionsPageviewByGender = {
        labels: pageviewByGenderLabels,
        dataLabels: {
          enabled: false,
        },
        responsive: [
          {
            breakpoint: 960,
            options: {
              chart: {
                width: 290,
              },
              legend: {
                show: true,
              },
            },
          },
        ],
        legend: {
          position: "bottom",
        },
      };

      this.chartOptionsPageviewByReferrer = {
        labels: pageviewByReferrerLables,
        dataLabels: {
          enabled: false,
        },
        responsive: [
          {
            breakpoint: 960,
            options: {
              chart: {
                width: 290,
              },
              legend: {
                show: true,
              },
            },
          },
        ],
        legend: {
          position: "bottom",
        },
      };

      this.chartOptionsPageviewBySite = {
        labels: pageviewBySiteLables,
        dataLabels: {
          enabled: false,
        },
        responsive: [
          {
            breakpoint: 960,
            options: {
              chart: {
                width: 290,
              },
              legend: {
                show: true,
              },
            },
          },
        ],
        legend: {
          position: "bottom",
        },
      };

      this.chartOptionsPageviewByTab = {
        labels: pageviewByTabLables,
        dataLabels: {
          enabled: false,
        },
        responsive: [
          {
            breakpoint: 960,
            options: {
              chart: {
                width: 290,
              },
              legend: {
                show: true,
              },
            },
          },
        ],
        legend: {
          position: "bottom",
        },
      };

      this.chartOptionsTotalPageview = {
        chart: {
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: pageviewTotalViewDailyLables,
        },
      };

      this.getReach();
    },
    getReach() {
      let reachDates = this.reach.dates;
      let reachStoryType = this.reach.story_type.impressions_by_story_type;
      let reachStoryTypeUnique =
        this.reach.story_type.impressions_by_story_type_unique;

      let reachStoryTypeImpressionsLables = Object.keys(reachStoryType);

      // Get an array of the keys in the reachStoryType object and sort them
      const storyTypeKeys = Object.keys(reachStoryType).sort();

      // Extract the values from the reachStoryType object in the order of the sorted keys
      this.reachStoryTypeImpressions = storyTypeKeys.map(
        (key) => reachStoryType[key]
      );

      // Get an array of the keys in the reachStoryTypeUnique object and sort them
      const uniqueKeys = Object.keys(reachStoryTypeUnique).sort();

      // Extract the values from the reachStoryTypeUnique object in the order of the sorted keys
      this.reachStoryTypeImpressionsUnique = uniqueKeys.map(
        (key) => reachStoryTypeUnique[key]
      );

      this.reachImpressionsOrganic = [
        {
          name: "Page Impressions Paid",
          data: this.reach.paid.page_impressions_paid,
        },
        {
          name: "Page Impressions Organic",
          data: this.reach.organic.page_impressions_organic,
        },
        {
          name: "Page Impressions Viral",
          data: this.reach.viral.page_impressions_viral,
        },
        {
          name: "Page Impressions Non-Viral",
          data: this.reach.nonviral.page_impressions_non_viral,
        },
      ];

      this.reachImpressionsOrganicUnique = [
        {
          name: "Page Impressions Paid",
          data: this.reach.paid.page_impressions_unique,
        },
        {
          name: "Page Impressions Organic",
          data: this.reach.organic.page_impressions_organic_unique,
        },
        {
          name: "Page Impressions Viral",
          data: this.reach.viral.page_impressions_viral_unique,
        },
        {
          name: "Page Impressions Non-Viral",
          data: this.reach.nonviral.page_impressions_non_viral_unique,
        },
      ];

      this.reachImpressionsAndOrganic = [
        {
          name: "Story Type Impressions",
          data: this.reachStoryTypeImpressions,
        },
        {
          name: "Story Type Impressions Unique",
          data: this.reachStoryTypeImpressionsUnique,
        },
      ];

      this.chartOptionsReachLineCharts = {
        chart: {
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: reachDates,
        },
      };

      this.chartOptionsImpressionsStoryType = {
        chart: {
          height: 350,
          events: {
            click: function (chart, w, e) {},
          },
        },
        plotOptions: {
          bar: {
            columnWidth: "45%",
            distributed: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        xaxis: {
          categories: reachStoryTypeImpressionsLables,
          labels: {
            style: {
              fontSize: "12px",
            },
          },
        },
      };

      this.getvideo();
    },
    getvideo() {
      let videoDate = this.video.views.dates;
      this.totalVideoView = this.video.views.totalViewTime;
      this.totalVideoOrganic = this.video.views.totalViewsOrganic;
      this.totalVideoPaid = this.video.views.totalViewsPaid;
      this.totalVideoViewSourceAutoPlay = this.video.viewSource.autoPlayCount;
      this.totalVideoViewSourceClickToPlay =
        this.video.viewSource.autoPlayCount;

      this.videoViewsOverall = [
        {
          name: "Organic",
          data: this.video.views.overall.organic,
        },
        {
          name: "Paid",
          data: this.video.views.overall.paid,
        },
        {
          name: "Repeat",
          data: this.video.views.overall.repeat,
        },
        {
          name: "Unique",
          data: this.video.views.overall.unique,
        },
      ];

      // this.videoViewsTenSec = [
      //   {
      //     name: "Organic",
      //     data: this.video.views.ten_sec.organic,
      //   },
      //   {
      //     name: "Paid",
      //     data: this.video.views.ten_sec.paid,
      //   },
      //   {
      //     name: "Repeat",
      //     data: this.video.views.ten_sec.repeat,
      //   },
      //   {
      //     name: "Unique",
      //     data: this.video.views.ten_sec.unique,
      //   },
      // ];

      this.videoViewsThrithySec = [
        {
          name: "Organic",
          data: this.video.views.thirty_sec.organic,
        },
        {
          name: "Paid",
          data: this.video.views.thirty_sec.paid,
        },
        {
          name: "Repeat",
          data: this.video.views.thirty_sec.repeat,
        },
        {
          name: "Unique",
          data: this.video.views.thirty_sec.unique,
        },
      ];

      this.autoAndClickViews = [
        {
          name: "Auto Play",
          data: this.video.viewSource.autoPlay,
        },
        {
          name: "Click To Play",
          data: this.video.viewSource.clickToPlay,
        },
      ];

      this.chartOptionsVideoOverall = {
        chart: {
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: videoDate,
        },
      };

      this.chartOptionsClickAndAutoPlay = {
        chart: {
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: videoDate,
        },
      };

      this.overlay = false;
    },
    backToSubscription() {
      if (this.activeSubscription == true) {
        this.$router.push({
          name: "singleSubscription",
          params: {
            uid: this.uid,
          },
        });
      } else if (this.cancelledSubscription == true) {
        this.$router.push({
          name: "singleCancelledSubscription",
          params: {
            uid: this.uid,
          },
        });
      }else if (this.pausedSubscription == true) {
        this.$router.push({
          name: "singlePausedSubscription",
          params: {
            uid: this.uid,
          },
        });
      }
    },
    closeInsights() {
      this.overlay = !this.overlay;
    },
  },
};
</script>

<style>
.bg {
  background-color: #3d6eb1;
  height: 100%;
}

.expanbg {
  background-image: url("../assets/Compeat-dash-test.jpg");
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}

.apexcharts-canvas {
  width: auto !important;
}

.apexcharts-toolbar {
  z-index: 8 !important;
}

.cardfont {
  font-size: 12px;
}
.cardtitle {
  height: 66px;
}
</style>
